export function Hero() {
  return (
    <section className="relative pt-28 pb-20 bg-[#fafafa] overflow-hidden">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div className="text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-brand-100 text-brand-700 text-sm font-medium mb-6">
              AI-First Hiring Decision System
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-surface-900 leading-tight">
              Hiring decisions you can{' '}
              <span className="text-brand-600">actually trust</span>
            </h1>

            <p className="mt-6 text-lg text-surface-600 max-w-xl mx-auto lg:mx-0">
              Jumpstone HR turns evidence into clear, comparable signal—so your team can decide with confidence, not gut feel.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4">
              <a href="/get-started" className="w-full sm:w-auto btn bg-brand-600 text-white hover:bg-brand-700 text-base px-8 py-3.5">
                Get Started
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="/#workflow" className="w-full sm:w-auto btn btn-secondary text-base px-8 py-3.5">
                See How It Works
              </a>
            </div>

            {/* Launch notice */}
            <p className="mt-10 text-sm text-surface-500">
              Works with recruiter-provided conversations — no scraping or private inbox access.
            </p>
          </div>

          {/* Right: Job Card Mockup */}
          <div className="relative">
            {/* Background glow */}
            <div className="absolute -inset-4 bg-gradient-to-r from-pink-200/20 to-purple-200/20 rounded-3xl blur-2xl" />
            
            {/* Main card */}
            <div className="relative">
              {/* Notification toast */}
              <div className="absolute -top-4 left-8 z-10 bg-white rounded-xl shadow-lg border border-surface-200 px-4 py-3 flex items-center gap-3 animate-float">
                <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                  <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-surface-900">Decision ready</p>
                  <p className="text-xs text-surface-500">High confidence</p>
                </div>
              </div>

              {/* Job card */}
              <div className="bg-white rounded-2xl shadow-xl border border-surface-200 p-6 mt-8">
                <div className="flex items-start justify-between mb-6">
                  <h3 className="text-lg font-bold text-surface-900">Product Designer</h3>
                  <span className="px-2.5 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">New</span>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <p className="text-xs text-surface-500 mb-1">Location</p>
                    <p className="text-sm font-medium text-surface-900">San Francisco, CA</p>
                  </div>
                  <div>
                    <p className="text-xs text-surface-500 mb-1">Department</p>
                    <p className="text-sm font-medium text-surface-900">Design</p>
                  </div>
                  <div>
                    <p className="text-xs text-surface-500 mb-1">Type</p>
                    <p className="text-sm font-medium text-surface-900">Full-time</p>
                  </div>
                  <div>
                    <p className="text-xs text-surface-500 mb-1">Experience</p>
                    <p className="text-sm font-medium text-surface-900">3+ years</p>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-surface-100">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-surface-200" />
                    <span className="text-sm text-surface-600">Added by Alex K.</span>
                  </div>
                  <button className="px-4 py-2 text-sm font-medium text-surface-900 border border-surface-300 rounded-lg hover:bg-surface-50">
                    View Job
                  </button>
                </div>
              </div>

              {/* Candidates badge */}
              <div className="absolute -bottom-4 right-8 bg-white rounded-xl shadow-lg border border-surface-200 px-4 py-3 flex items-center gap-3 animate-float" style={{ animationDelay: '-3s' }}>
                <div className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center">
                  <svg className="w-4 h-4 text-brand-600" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-semibold text-surface-900">Signal extracted</p>
                  <p className="text-xs text-surface-500">4 evaluators aligned</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
